module.exports = __webpack_public_path__ + "media/explosion_medium.c016446a.mp3";